var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modalContents__object09" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row no-gutters" }, [
        _c(
          "div",
          { staticClass: "col-lg-7 col-md-8 col-10 mx-auto row no-gutters" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-8 mx-auto" }, [
              _c(
                "a",
                {
                  staticClass: "text-center globalModal--btn",
                  attrs: { href: "javascript:void(0)" },
                  on: { click: _vm.showModalLogin }
                },
                [_vm._v("ログインページへ")]
              )
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "col-12 text-center" }, [
      _vm._v("パスワードの再設定用のリンクを"),
      _c("br"),
      _vm._v("ご登録いただいたメールアドレス宛に"),
      _c("br"),
      _vm._v("送信いたしました。"),
      _c("br"),
      _c("br"),
      _vm._v("メールをご確認の上"),
      _c("br"),
      _vm._v("再設定してください。")
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b0c3043e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0c3043e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/vue/component/modal/lost_password_thanks.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-b0c3043e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/vue/component/modal/lost_password_thanks.vue
// module chunks = 0